import React, { useEffect, useState } from 'react'
import DropDownSelect from './index'
import { get } from '../../../lib/api'

const DependentDropDown = ({
  dependentOn,
  language,
  api,
  params,
  transformResponse,
  is_novel = 0,
  selectedContest,
  ...props
}) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    if (!dependentOn || !language) return
    get(api, { params : {...params, is_novel: 1} }).then((response) => {
      const filteredCategoryList = transformResponse(response)
      if (selectedContest && filteredCategoryList.length > 0) {
        const contestCategory = selectedContest?.type
        filteredCategoryList = filteredCategoryList?.filter((topic) =>
          topic.topic_name.toLowerCase().includes(contestCategory)
        )
      }
      setOptions(filteredCategoryList)
    })
  }, [dependentOn, language, selectedContest])

  return (
    <DropDownSelect
      selectOptions={options}
      dependentOn={dependentOn}
      resetKey={language}
      {...props}
    />
  )
}

// TODO : make it reusable, check better way to pass dependent variables
export default DependentDropDown
